<div class="button-with-label">
    <span class="button-label">{{ label | translate }}</span>

    <!-- the same pill as in the ticket list, a size up: icon, value and a
         caret that says it opens something. One button, so the whole thing is
         the target rather than just the circle. -->
    <button
        class="choice-pill"
        (click)="onClickChoice()"
        [disabled]="disabled || locked"
        >
        <mat-icon *ngIf="status !== 1 && shownIcon">{{ shownIcon }}</mat-icon>
        <mat-icon *ngIf="status === 1">hourglass_empty</mat-icon>

        <span class="choice-value" *ngIf="topic !== 'multi-action'">
            {{ selectedLabel | async }}
        </span>

        <mat-icon class="choice-caret">arrow_right</mat-icon>
    </button>
</div>
